import { LoginCard } from '../components/LoginCard';

export function LoginPage() {
  return (
    <div className="p-4 md:p-10 flex items-center justify-center">
      <LoginCard />
    </div>
  );
}
